import React from "react";
import styles from "./page6.module.scss";
import { Button } from "@mui/material";
import arrow from "../../images/arrowWhite.svg";
import arrowgrt from "../../icons/arrow_grt.svg";
import block from "../../images/codegif.gif";
import { useNavigate } from "react-router-dom";

export default function Page6() {
  const navigate = useNavigate();
  return (
    <div className={styles.mainwrapper}>
      <div className={styles.left}>
        <div className={styles.imagecontainer}>
          <img className={styles.firstimage} src={arrowgrt} alt="arrowgrt" />
        </div>
        <div>
          <p className={styles.smallheading}>DEVELOPERS</p>
        </div>
        <div>
          <p className={styles.bigheading}>
            Integrated Ecosystem for Developers
          </p>
        </div>
        <div>
          <p className={styles.bigpara}>
            Firstock Connect provides low-code SDKs and RESTful APIs that work
            quickly with existing apps and ecosystems.
          </p>
        </div>
        <div className={styles.button}>
          <Button
            startIcon={
              <div
                style={{
                  background: "#6D00FF",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <img src={arrow} alt="" />
              </div>
            }
            variant="outlined"
            sx={{
              my: 2,
              color: "black",
              fontWeight: "600",

              // bgcolor: "#6D00FF",
              padding: "5px 20px 5px 10px",
              borderRadius: "50px",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#6D00FF",
                transition: "0.3s ease-in-out",
                color: "white",
                "& .MuiButton-startIcon": {
                  transform: "rotate(45deg)",
                  transition: "0.3s ease-in-out",
                },
              },
            }}
            onClick={() => {
             // navigate("docsv3");
              window.open("https://wikiconnect.thefirstock.com/","_blank")
              // window.open(
              //   "https://connect.thefirstock.com/docsv3/docs/get-started/packages-instalation/",
              //   "_blank"
              // );
            }}
          >
            View Documentation
          </Button>
        </div>
      </div>
      <div className={styles.right}>
        <div>
          <img src={block} alt="block" style={{ width: "100%" }} />
        </div>
      </div>
    </div>
  );
}
